import branch from "branch-sdk";

const BRANCH_KEY = "key_live_bCCFegOpGGbDhZCh44mKngmhAEjGbz5O";

let branchInitPromise = null;
let branchSessionData = null;

function isBrowser() {
  return typeof window !== "undefined";
}

export function initBranch() {
  if (!isBrowser()) {
    return Promise.resolve(null);
  }

  if (branchInitPromise) {
    return branchInitPromise;
  }

  if (!BRANCH_KEY) {
    console.warn(
      "[Branch] Geen Branch key gevonden. Branch wordt niet geïnitialiseerd."
    );
    branchInitPromise = Promise.resolve(null);
    return branchInitPromise;
  }

  branchInitPromise = new Promise((resolve) => {
    try {
      branch.init(BRANCH_KEY, (err, data) => {
        if (err) {
          console.error("[Branch] Initialisatie mislukt:", err);
          resolve(null);
          return;
        }

        branchSessionData = (data && (data.data_parsed || data)) || null;
        resolve(branch);
      });
    } catch (initialisationError) {
      console.error("[Branch] Onverwachte fout bij init:", initialisationError);
      resolve(null);
    }
  });

  return branchInitPromise;
}

export async function getBranchSessionData() {
  const instance = await initBranch();
  if (!instance) {
    return null;
  }
  if (branchSessionData && Object.keys(branchSessionData).length > 0) {
    return branchSessionData;
  }
  try {
    const latest = await new Promise((resolve) => {
      try {
        branch.data((err, data) => {
          if (err) {
            resolve(null);
            return;
          }
          resolve((data && (data.data_parsed || data)) || null);
        });
      } catch (error) {
        resolve(null);
      }
    });
    if (latest) {
      branchSessionData = latest;
      return branchSessionData;
    }
  } catch (error) {
    console.warn("[Branch] kon sessie-data niet verversen", error);
  }
  return branchSessionData;
}

export async function getBranchCustomGame() {
  const sessionData = await getBranchSessionData();
  
  
  if (!sessionData) {
    return null;
  }

  const rawTheme =
    sessionData.theme ||
    sessionData.Theme ||
    sessionData.customTheme ||
    sessionData.custom_theme ||
    sessionData.$canonical_identifier;

  const rawWords =
    sessionData.words ||
    sessionData.Words ||
    sessionData.customWords ||
    sessionData.custom_words;

  const rawCreator =
    sessionData.creator ||
    sessionData.Creator ||
    sessionData.author ||
    sessionData.Author ||
    sessionData.owner ||
    sessionData.Owner ||
    sessionData.name ||
    sessionData.Name;

  const rawLang =
    sessionData.lang ||
    sessionData.language ||
    sessionData.Language;


  if (!rawTheme || !rawWords) {
    return null;
  }

  const theme = String(rawTheme).trim();

  let wordsArray = [];
  if (Array.isArray(rawWords)) {
    wordsArray = rawWords;
  } else if (typeof rawWords === "string") {
    try {
      const parsed = JSON.parse(rawWords);
      if (Array.isArray(parsed)) {
        wordsArray = parsed;
      } else {
        wordsArray = rawWords.split(/[;,\n]/).map((w) => w.trim());
      }
    } catch (err) {
      wordsArray = rawWords.split(/[;,\n]/).map((w) => w.trim());
    }
  }

  const normalizedWords = wordsArray
    .map((w) => (typeof w === "string" ? w.trim() : ""))
    .filter((w) => w.length > 0);

  if (!theme || normalizedWords.length === 0) {
    return null;
  }

  return {
    theme,
    words: normalizedWords.map((w) => w.toUpperCase()),
    creator: rawCreator ? String(rawCreator).trim() : "",
    lang: rawLang ? String(rawLang).trim().toLowerCase() : "",
  };
}

export async function createWordHitLink({ theme, words, creator, lang }) {
  const branchInstance = await initBranch();
  if (!branchInstance) {
    return null;
  }

  const cleanedWords = words
    .map((word) => word.trim())
    .filter((word) => word.length > 0);

  const creatorName = creator ? String(creator).trim() : "";
  const langValue = lang ? String(lang).trim().toLowerCase() : "";

  const linkData = {
    channel: "custom-wordhit",
    feature: "share",
    campaign: "user-generated",
    data: {
      $deeplink_path: "/custom",
      theme,
      words: cleanedWords,
      creator: creatorName,
      lang: langValue,
      $web_only: true,
    },
  };

  return new Promise((resolve) => {
    branchInstance.link(linkData, (err, url) => {
      if (err) {
        console.error("[Branch] Link creatie mislukt:", err);
        resolve(null);
        return;
      }
      resolve(url);
    });
  });
}

